import { OrgPartSchema, LifecycleStatusOptions } from 'types/clientV2/parts';
import { PartCore, lifecycleStatus } from 'types/part';

export const isOrgPartSchema = (
  part: OrgPartSchema | string | undefined
): part is OrgPartSchema =>
  typeof part === 'object' &&
  part !== null &&
  'id' in part &&
  'cofactrId' in part;

export const findV2OrgPartById = (
  v2OrgParts: (OrgPartSchema | string)[] | undefined,
  id: string | undefined
): OrgPartSchema | undefined => {
  if (!id) {
    return undefined;
  }
  return v2OrgParts?.find(
    (part): part is OrgPartSchema => isOrgPartSchema(part) && part.id === id
  );
};

export const findV2OrgPartByCofactrId = (
  v2OrgParts: (OrgPartSchema | string)[] | undefined,
  cofactrId: string
): OrgPartSchema | undefined =>
  v2OrgParts?.find(
    (part): part is OrgPartSchema =>
      isOrgPartSchema(part) && part.cofactrId === cofactrId
  );

export const orgPartSchemaToPartCore = (orgPart: OrgPartSchema): PartCore => {
  const lifecycleStatusMap: Record<
    LifecycleStatusOptions,
    lifecycleStatus | null
  > = {
    [LifecycleStatusOptions.EOL]: lifecycleStatus.EOL,
    [LifecycleStatusOptions.NEW]: lifecycleStatus.NEW,
    [LifecycleStatusOptions.NRFND]: lifecycleStatus.NRFND,
    [LifecycleStatusOptions.OBSOLETE]: lifecycleStatus.OBSOLETE,
    [LifecycleStatusOptions.PRODUCTION]: lifecycleStatus.PRODUCTION,
  };

  return {
    id: orgPart.cofactrId ?? orgPart.publicPart?.cofactrId ?? '',
    customId: orgPart.customId,
    mpn: orgPart.mpn,
    classification: orgPart.classification,
    description: orgPart.description,
    lifecycleStatus:
      orgPart.lifecycleStatus !== null
        ? lifecycleStatusMap[orgPart.lifecycleStatus] ?? null
        : null,
    heroImage: orgPart.heroImage,
    mfg: orgPart.manufacturer,
    package: orgPart.package,
    terminations:
      orgPart.terminations !== null ? String(orgPart.terminations) : null,
    terminationType: orgPart.terminationType ?? '',
    deprecatedBy: null,
    msl: orgPart.msl !== null ? String(orgPart.msl) : null,
    isCustomizedInfo: false,
    altMpns: orgPart.aliasMpns,
    mfgAliases: orgPart.aliasMfgs,
    reach: orgPart.reach !== null ? orgPart.reach : undefined,
    rohs: orgPart.rohs !== null ? orgPart.rohs : undefined,
    aec: orgPart.aec !== null ? orgPart.aec : undefined,
    htsus: orgPart.htsus,
    coo: orgPart.coo,
    dimensionClass: orgPart.dimensionClass,
    preferredUnit: orgPart.preferredUnit ?? null,
    v2OrgPart: orgPart.id,
  };
};
